import { render, staticRenderFns } from "./CustomerAddNew.vue?vue&type=template&id=62e15fa3&scoped=true&"
import script from "./CustomerAddNew.vue?vue&type=script&lang=js&"
export * from "./CustomerAddNew.vue?vue&type=script&lang=js&"
import style0 from "./CustomerAddNew.vue?vue&type=style&index=0&id=62e15fa3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e15fa3",
  null
  
)

export default component.exports